import * as React from 'react';
import { ERealEstateType } from '../../types/suburban';
import * as styles from './RealEstateTabs.css';
import cn from 'classnames';
import { REAL_ESTATE_TYPE_TABS } from '../../constants/suburban';

interface IRealEstateTabsProps {
  activeTab: ERealEstateType;
  onTabChange: (id: ERealEstateType) => (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const tabsArray = Object.keys(REAL_ESTATE_TYPE_TABS).map((tabId: ERealEstateType) => ({
  title: REAL_ESTATE_TYPE_TABS[tabId],
  id: tabId,
}));

export const RealEstateTabs: React.VFC<IRealEstateTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles['tabs']}>
      {tabsArray.map(({ title, id }) => {
        const isActive = id === activeTab;

        return (
          <button key={id} onClick={onTabChange(id)} className={cn(styles['tab'], isActive && styles['active'])}>
            <div className={cn(styles['inner'], styles[id])}>{title}</div>
          </button>
        );
      })}
    </div>
  );
};
